import { render, staticRenderFns } from "./ucHead.vue?vue&type=template&id=057dea46"
import script from "./ucHead.vue?vue&type=script&lang=js"
export * from "./ucHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports